import { storeAsync } from '@/app-module';

export default {
    async beforeRouteEnter(to, from, next) {
        if (!to.meta || !to.meta.auth) {
            next();
            return;
        }
        const store = storeAsync();
        const profileCompleted = store.getters['auth/currentUser'].profile_completed;
        const profileNeedsUpdate = store.getters['auth/currentUser'].profile_needs_update;

        if (to.name !== 'home' && !profileCompleted) {
            next({ path: '/' });
            return
        }

        if (to.name !== 'home' && to.name !== 'profile' && profileNeedsUpdate) {
            next({ path: '/' });
            return
        }
        next();
    }
};
